import { motion } from "framer-motion";
import { processSteps } from "../lib/data";

const Process = () => {
  return (
    <section id="process" className="py-24 md:py-36 relative" data-testid="process">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="section-label mb-6">© Approach</div>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-end mb-16 md:mb-24">
          <h2 className="md:col-span-8 h-display text-5xl md:text-7xl lg:text-8xl">
            AI accelerates. <span className="italic font-serif">Judgment</span> shapes.
          </h2>
          <p className="md:col-span-4 text-[color:var(--nn-muted)] text-sm md:text-base leading-relaxed">
            A repeatable process built for products that can't afford to guess — from EdTech
            classrooms to enterprise hiring rooms.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {processSteps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 }}
              className="group relative p-8 rounded-2xl border border-[color:var(--nn-border)] bg-[color:var(--nn-surface)]/50 backdrop-blur hover:-translate-y-2 hover:border-[color:var(--nn-accent)]/50 transition-all duration-500"
              data-testid={`process-step-${s.n}`}
            >
              <div className="flex items-start justify-between mb-8">
                <span className="font-mono text-xs tracking-widest text-[color:var(--nn-muted)]">({s.n})</span>
                <div className="w-2 h-2 rounded-full bg-[color:var(--nn-accent)] opacity-40 group-hover:opacity-100 transition-opacity" />
              </div>
              <h3 className="font-serif text-3xl md:text-4xl tracking-tight mb-4">{s.title}</h3>
              <p className="text-[color:var(--nn-muted)] leading-relaxed text-sm">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
